module.exports = __webpack_public_path__ + "img/img35.1b2a5026.svg";